
import { Component, OnInit } from '@angular/core';
import { EventService } from 'src/app/_services/generatedServices';
import { EventViewModel, EventSearchParameters, ConferenceViewModel, ConferenceViewModelSimple } from 'src/app/_models/generatedModels';
import { SettingsProvider } from 'src/app/_services/settingsProvider.service';

@Component({
  selector: 'bxl-conference-listing',
  templateUrl: 'conference-listing.component.html',
})
export class ConferenceListingComponent implements OnInit {
  events: EventViewModel[];
  initialized: boolean;
  conferences: ConferenceViewModelSimple[];
  showPastConferences: boolean = false;
  loading: boolean = false;

  constructor(private eventService: EventService) {}

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.loading = true;
    if (this.showPastConferences) {
      this.eventService.getPastConferences().subscribe((conf) => {
        this.conferences = conf;
        this.initialized = true;
        this.loading = false;
      });
    } else {
      this.eventService.getUpcomingConferences(true).subscribe((conf) => {
        this.conferences = conf;
        this.initialized = true;
        this.loading = false;
      });
    }
  }

  onPastConferencesToggle() {
    this.showPastConferences = !this.showPastConferences;
    this.getData();
  }
}
